module.exports = __webpack_public_path__ + "img/icon-probation.1d2f6efc.png";